// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"Collaps_collapsible__7lfii","content":"Collaps_content__MZyGt"};